module.exports = __webpack_public_path__ + "44a526eed258222515aa21eaffd14a96.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/marker-shadow.png
// module id = 60
// module chunks = 0